/* GÉNÉRÉ depuis sweatix-defi/src/simulation.js — NE PAS MODIFIER ICI.
   Toute retouche doit passer par la source puis `node build-sim.mjs`,
   sinon le serveur et le jeu divergent et toutes les parties sont rejetées. */
/* =====================================================================
   Simulation du Défi Slalom — LE CONTRAT.

   Ce fichier est dupliqué à l'identique dans le thème Shopify
   (assets/jeu-slalom-sim.js) et dans le Worker. Le navigateur joue la
   partie, le serveur la REJOUE à partir de la même graine et de la même
   suite de mouvements, puis compare les scores. Si les deux fichiers
   divergent d'un cheveu, toutes les parties sont rejetées.

   Règles de déterminisme, à respecter si on y touche :
   - pas de Math.random : uniquement le générateur à graine ci-dessous ;
   - pas de Math.sin / cos / pow : leur résultat n'est pas garanti
     identique d'un moteur JS à l'autre. Seulement + - * / et
     abs/min/max/floor, qui sont exacts en IEEE 754 ;
   - pas de dt variable : le pas de temps est fixe.
   Le rebond du ballon et son inclinaison sont PUREMENT visuels et vivent
   donc dans le jeu, pas ici.
   ===================================================================== */

var DT = 1 / 60;          /* pas de temps fixe */
var ZFAR = 26;            /* horizon, en mètres */
var PZ = 0.55;            /* position du ballon en profondeur */
var MAX_TICKS = 60 * 60 * 12;  /* garde-fou : 12 minutes de jeu */

/* mulberry32 : court, rapide, et n'utilise que des opérations entières
   exactes (Math.imul, décalages) — donc identique partout. */
function creerHasard(graine){
  var a = graine >>> 0;
  return function(){
    a = (a + 0x6D2B79F5) >>> 0;
    var t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function etatInitial(){
  return {
    px: 0, pxCible: 0,
    dist: 0, score: 0, vies: 3, combo: 1, gates: 0,
    niveau: 1, vitesse: 6.6, inv: 0,
    obstacles: [], prochainZ: 10,
    fini: false,
    evenements: []   /* consommé par le jeu pour l'affichage, ignoré par le serveur */
  };
}

function poserRangee(S, hasard){
  var lvl = S.niveau;
  var r = hasard();
  var z = S.prochainZ;
  var ecart = Math.max(2.0, 4.4 - lvl * 0.16);

  if(r < 0.30){
    S.obstacles.push({ t:'cone', wx: hasard() * 1.6 - 0.8, z: z });
  } else if(r < 0.58){
    var c = hasard() * 1.0 - 0.5;
    var demi = Math.max(0.24, 0.36 - lvl * 0.008);
    S.obstacles.push({ t:'pole', wx: c - demi, z: z });
    S.obstacles.push({ t:'pole', wx: c + demi, z: z });
    S.obstacles.push({ t:'gate', wx: c, demi: demi, z: z });
  } else if(r < 0.82){
    var trou = hasard() * 1.2 - 0.6;
    S.obstacles.push({ t:'cone', wx: Math.max(-0.88, trou - 0.52), z: z });
    S.obstacles.push({ t:'cone', wx: Math.min(0.88, trou + 0.52), z: z });
  } else {
    var libre = Math.floor(hasard() * 3);
    for(var i = 0; i < 3; i++){
      if(i === libre) continue;
      S.obstacles.push({ t:'cone', wx: -0.62 + i * 0.62, z: z });
    }
  }
  S.prochainZ = z + ecart;
}

/* Un pas de simulation. Renvoie false quand la partie est finie. */
function pas(S, hasard){
  if(S.fini) return false;

  var d = S.pxCible - S.px;
  S.px += d * Math.min(1, DT * 14);

  var avance = S.vitesse * DT;
  S.dist += avance;
  S.score += avance * 2;

  var nv = 1 + Math.floor(S.score / 800);
  if(nv > S.niveau){
    S.niveau = nv;
    S.vitesse = Math.min(19, 6.6 + (nv - 1) * 0.9);
    S.evenements.push({ e:'niveau', n: nv });
  }

  if(S.inv > 0) S.inv -= DT;

  while(S.prochainZ - S.dist < ZFAR) poserRangee(S, hasard);

  for(var i = S.obstacles.length - 1; i >= 0; i--){
    var o = S.obstacles[i];
    var zAvant = o.z - (S.dist - avance);
    var zApres = o.z - S.dist;

    if(zAvant > PZ && zApres <= PZ){
      if(o.t === 'gate'){
        if(Math.abs(S.px - o.wx) < o.demi){
          S.gates++;
          var pts = 40 * S.combo;
          S.score += pts;
          S.evenements.push({ e:'slalom', pts: pts, wx: o.wx });
          S.combo = Math.min(8, S.combo + 1);
        } else {
          S.combo = 1;
        }
      } else if(S.inv <= 0){
        var seuil = (o.t === 'cone') ? 0.135 : 0.105;
        var ecart = Math.abs(S.px - o.wx);
        if(ecart < seuil){
          S.vies--; S.combo = 1; S.inv = 1.3;
          S.vitesse = Math.max(5.5, S.vitesse - 1.2);
          S.evenements.push({ e:'choc', wx: o.wx });
          if(S.vies <= 0){ S.fini = true; return false; }
        } else if(ecart < seuil + 0.10){
          S.score += 10;
          S.evenements.push({ e:'frole', wx: o.wx });
        }
      }
    }
    if(zApres < -1.5) S.obstacles.splice(i, 1);
  }
  return true;
}

/* Rejoue une partie complète. `entrees` = [[tick, x*1000], ...] trié. */
function rejouer(graine, entrees, ticks){
  var hasard = creerHasard(graine);
  var S = etatInitial();
  var ie = 0;
  var n = Math.min(ticks, MAX_TICKS);
  for(var tick = 0; tick < n; tick++){
    while(ie < entrees.length && entrees[ie][0] <= tick){
      S.pxCible = Math.max(-0.86, Math.min(0.86, entrees[ie][1] / 1000));
      ie++;
    }
    S.evenements.length = 0;
    if(!pas(S, hasard)) break;
  }
  return {
    score: Math.floor(S.score),
    dist: Math.floor(S.dist),
    gates: S.gates,
    vies: S.vies,
    fini: S.fini
  };
}